import React from "react";
import { Button, Paper, TextField, Grid } from "@mui/material";
import { useMutation } from "@apollo/client";
import { useFormik } from "formik";
import * as Yup from "yup";
import Iconify from "../../../../components/Iconify";
import { AGREGAR_FLUJO_CAJA } from "../../../../graphql/bancos";

const FrmAgregarFlujo = ({ setOpenDialog, setOpenSnackBar, setErrorGraph, refetch }) => {
  const [crearSaldoInicial] = useMutation(AGREGAR_FLUJO_CAJA);

  const formik = useFormik({
    initialValues: {
      periodo: "",
      saldo_inicial: "",
    },
    validationSchema: Yup.object({
      periodo: Yup.string()
        .matches(/^\d{4}-\d{2}$/, "Formato inválido. Use YYYY-MM (Ej. 2024-01)")
        .required("El periodo es requerido"),
      saldo_inicial: Yup.number()
        .typeError("Debe ser un número")
        .min(0, "Debe ser mayor o igual a 0")
        .required("El saldo inicial es requerido"),
    }),
    onSubmit: async (values, { resetForm }) => {
      try {
        await crearSaldoInicial({
          variables: {
            
              periodo: values.periodo,
              saldo_inicial: parseFloat(values.saldo_inicial),
            
          },
        });

        // Mostrar mensaje de éxito
        setOpenSnackBar(true);
        setErrorGraph({ mensaje: "Flujo de caja agregado correctamente", severity: "success" });

        // Volver a cargar los datos
        refetch();

        // Resetear formulario y cerrar modal
        resetForm();
        setOpenDialog(false);
      } catch (error) {
        setOpenSnackBar(true);
        setErrorGraph({ mensaje: error.message, severity: "error" });
      }
    },
  });

  return (
    <form onSubmit={formik.handleSubmit}>
      <Paper style={{ padding: 10 }}>
        <Grid container alignItems="flex-start" spacing={3}>
          <Grid item xs={12}>
            <TextField
              id="periodo"
              name="periodo"
              label="Periodo (ejemplo 2024-01)"
              variant="standard"
              fullWidth
              value={formik.values.periodo}
              onChange={formik.handleChange}
              onBlur={formik.handleBlur}
              error={formik.touched.periodo && Boolean(formik.errors.periodo)}
              helperText={formik.touched.periodo && formik.errors.periodo}
            />
          </Grid>
          <Grid item xs={12}>
            <TextField
              id="saldo_inicial"
              name="saldo_inicial"
              label="Saldo inicial"
              variant="standard"
              fullWidth
              value={formik.values.saldo_inicial}
              onChange={formik.handleChange}
              onBlur={formik.handleBlur}
              error={formik.touched.saldo_inicial && Boolean(formik.errors.saldo_inicial)}
              helperText={formik.touched.saldo_inicial && formik.errors.saldo_inicial}
            />
          </Grid>
          <Grid item xs={12} md={6}>
            <Button type="submit" startIcon={<Iconify icon="eva:save-outline" />}>
              Guardar
            </Button>
            <Button
              onClick={() => setOpenDialog(false)}
              color="error"
              startIcon={<Iconify icon="eva:close-outline" />}
            >
              Cerrar
            </Button>
          </Grid>
        </Grid>
      </Paper>
    </form>
  );
};

export default FrmAgregarFlujo;



